import { Fragment, useEffect } from 'react';
import { useNavigate } from 'react-router';

import { Button } from '@mui/material'

import { TituloPagina, TituloSecao } from 'esocial.web.react.lib/cjs/components/util/Text';
import { ContainerSecao, ContainerLateral, ContainerBotaoDireita, ContainerCampoETitulo } from 'esocial.web.react.lib/cjs/components/simples/Containers';

import { TextoInstrucao } from 'esocial.web.react.lib/cjs/components/simples/Textos'
import { CampoData } from 'esocial.web.react.lib/cjs/components/simples/campos/CampoData';
import { SeletorCheckboxLateral } from 'esocial.web.react.lib/cjs/components/simples/campos/SeletorCheckboxLateral'
import { CampoComMascara, MascaraEnum } from 'esocial.web.react.lib/cjs/components/simples/campos/CampoComMascara';
import { SeletorOpcoes } from 'esocial.web.react.lib/cjs/components/simples/campos/SeletorOpcoes';
import SeletorOpcoesAutocompleteGrupo from 'esocial.web.react.lib/cjs/components/simples/campos/SeletorOpcoesAutocompleteGrupo';

import { useAppDispatch } from 'esocial.web.react.lib/cjs/hooks/Reduz';

import { useRequisicaoControlada } from 'esocial.web.react.lib/cjs/hooks/RequisicaoControlada';

import { useRelatoriosGerenciaisContext } from '../../contexts/RelatoriosGerenciaisContext';

import { salvarNovaSolicitacaoRelatorio, getConstantes } from './auxiliares/RelatoriosGerenciaisRequests';
import { CampoEstabelecimentos } from './auxiliares/CampoEstabelecimentos';


function isNullOrEmpty(variavel) {
    return variavel == null || variavel == '';
}


const Filtros = () => {

    const { incluiTrabalhadoresAtivos, setIncluiTrabalhadoresAtivos,
        incluiTrabalhadoresPCD, setIncluiTrabalhadoresPCD,
        desconsiderarAnotacoesJudiciais, setDesconsiderarAnotacoesJudiciais,
        cpfTrabalhador, setCpfTrabalhador,
        categorias, setCategorias, opcoesCategorias,
        cbo, setCbo, opcoesCBO,
        tipoEstabelecimento, setTipoEstabelecimento,
        estabelecimentos, setEstabelecimentos, opcoesTipoEstabelecimento,
        periodoAdmissaoInicio, setPeriodoAdmissaoInicio,
        periodoAdmissaoFim, setPeriodoAdmissaoFim,
        periodoDesligamentoInicio, setPeriodoDesligamentoInicio,
        periodoDesligamentoFim, setPeriodoDesligamentoFim,
        semFiltros, setSemFiltros
    } = useRelatoriosGerenciaisContext();

    const limparFiltros = () => {
        setIncluiTrabalhadoresAtivos(false);
        setIncluiTrabalhadoresPCD(false);
        setDesconsiderarAnotacoesJudiciais(false);
        setCpfTrabalhador('');
        setCategorias([]);
        setCbo([]);
        setTipoEstabelecimento('');
        setEstabelecimentos('');
        setPeriodoAdmissaoInicio('');
        setPeriodoAdmissaoFim('');
        setPeriodoDesligamentoInicio('');
        setPeriodoDesligamentoFim('');
    };

    useEffect(() => {
        if (semFiltros) {
            limparFiltros();
        }
    }, [semFiltros]);

    useEffect(() => {
        const isAnyFieldFilled = incluiTrabalhadoresAtivos || incluiTrabalhadoresPCD || desconsiderarAnotacoesJudiciais ||
            cpfTrabalhador || categorias.length > 0 || cbo.length > 0 || tipoEstabelecimento || estabelecimentos ||
            periodoAdmissaoInicio || periodoAdmissaoFim || periodoDesligamentoInicio || periodoDesligamentoFim;

        setSemFiltros(!isAnyFieldFilled);
    }, [incluiTrabalhadoresAtivos, incluiTrabalhadoresPCD, desconsiderarAnotacoesJudiciais,
        cpfTrabalhador, categorias, cbo, tipoEstabelecimento, estabelecimentos, periodoAdmissaoInicio, periodoAdmissaoFim, periodoDesligamentoInicio, periodoDesligamentoFim]);

    if (incluiTrabalhadoresAtivos) {
        setPeriodoDesligamentoInicio('');
        setPeriodoDesligamentoFim('');
    }

    return (
        <ContainerSecao sx={{ gap: '1rem' }}>
            <SeletorCheckboxLateral
                label={'Todos os vínculos do eSocial'}
                variavel={semFiltros}
                setVariavel={setSemFiltros}
                tooltip={true}
                disableIfChecked={true}
                tooltipText={'Por padrão, o sistema retorna todos os vínculos já registrados pelo empregador no eSocial que não tenham sido excluídos'}
            />
            <ContainerCampoETitulo>
                <TextoInstrucao sx={{marginBottom: '1rem'}}>Caso deseje restringir os resultados da pesquisa, selecione os filtros abaixos: </TextoInstrucao>
                <ContainerLateral sx={{gap: '0.9rem'} }>
                    <SeletorCheckboxLateral
                        label={'Apenas trabalhadores ativos'}
                        variavel={incluiTrabalhadoresAtivos}
                        setVariavel={setIncluiTrabalhadoresAtivos}
                    />
                    <SeletorCheckboxLateral
                        maxWidth={300}
                        label={'Apenas trabalhadores informados como pessoa com deficiência ou reabilitado'}
                        variavel={incluiTrabalhadoresPCD}
                        setVariavel={setIncluiTrabalhadoresPCD}
                    />
                    <SeletorCheckboxLateral
                        label={'Desconsiderar anotações judiciais (evento S-8200)'}
                        variavel={desconsiderarAnotacoesJudiciais}
                        setVariavel={setDesconsiderarAnotacoesJudiciais}
                    />
                </ContainerLateral>
            </ContainerCampoETitulo>

            <ContainerLateral>
                <CampoComMascara
                    mascaraTipo={MascaraEnum.CPF}
                    label={'CPF Trabalhador'}
                    variavel={cpfTrabalhador}
                    setVariavel={setCpfTrabalhador}
                />
                <SeletorOpcoesAutocompleteGrupo
                    label={'Categorias'}
                    variavel={categorias}
                    setVariavel={setCategorias}
                    opcoes={opcoesCategorias}
                    width={490}
                />
                <SeletorOpcoesAutocompleteGrupo
                    label={'CBO'}
                    variavel={cbo}
                    setVariavel={setCbo}
                    width={300}
                    opcoes={opcoesCBO}
                />
            </ContainerLateral>

            <ContainerLateral sx={{ alignItems: 'flex-end' }}>
                <SeletorOpcoes
                    label={'Tipo de Estabelecimento'}
                    variavel={tipoEstabelecimento}
                    setVariavel={setTipoEstabelecimento}
                    opcoes={opcoesTipoEstabelecimento}
                />
                <CampoEstabelecimentos
                    label={'Estabelecimentos'}
                    tooltip={true}
                    tooltipText={'Indique os estabelecimentos no formato: NUMERO1; NUMERO2; ...'}
                    variavel={estabelecimentos}
                    setVariavel={setEstabelecimentos}
                    flexGrow={1}
                />
            </ContainerLateral>

            <ContainerLateral>
                <CampoData
                    label={'Data de admissão a partir de:'}
                    variavel={periodoAdmissaoInicio}
                    setVariavel={setPeriodoAdmissaoInicio}
                    width={200}
                />
                <CampoData
                    label={'Data de admissão até:'}
                    variavel={periodoAdmissaoFim}
                    setVariavel={setPeriodoAdmissaoFim}
                    width={200}
                />
                <CampoData
                    bloqueado={incluiTrabalhadoresAtivos}
                    label={'Data de desligamento a partir de:'}
                    variavel={periodoDesligamentoInicio}
                    setVariavel={setPeriodoDesligamentoInicio}
                    width={200}
                />
                <CampoData
                    bloqueado={incluiTrabalhadoresAtivos}
                    label={'Data de desligamento até:'}
                    variavel={periodoDesligamentoFim}
                    setVariavel={setPeriodoDesligamentoFim}
                    width={200}
                />
            </ContainerLateral>
        </ContainerSecao>
    )
}

const RelatoriosGerenciaisRegistro = () => {
    const { tipoInscricaoSolicitante, numeroInscricaoSolicitante, opcoesCBO, setOpcoesTipoRelatorio, setDescricaoSituacao, setOpcoesTipoEstabelecimento, setOpcoesCBO, setOpcoesCategorias,
        incluiTrabalhadoresAtivos, incluiTrabalhadoresPCD, desconsiderarAnotacoesJudiciais, cpfTrabalhador, categorias, cbo, tipoEstabelecimento, estabelecimentos,
        periodoAdmissaoInicio, periodoAdmissaoFim, periodoDesligamentoInicio, periodoDesligamentoFim, tipoRelatorio, tipoInscricaoEmpregador, numeroInscricaoEmpregador, setRelatoriosSolicitados, relatoriosSolicitados
    } = useRelatoriosGerenciaisContext();

    const dispatch = useAppDispatch();
    const { post } = useRequisicaoControlada();
    const navigate = useNavigate();

    const handleSolicitarRelatorio = () => {
        let relatorio = {
            Empregador: {
                Tipo: tipoInscricaoEmpregador,
                Numero: numeroInscricaoEmpregador.replace(/[^a-zA-Z0-9]/g, '')
            },
            Solicitante: {
                Tipo: tipoInscricaoSolicitante,
                Numero: numeroInscricaoSolicitante.replace(/[^a-zA-Z0-9]/g, '')
            },
            Tipo: tipoRelatorio,
            Situacao: 1,
            Filtro: JSON.stringify({
                trabalhadoresAtivos: incluiTrabalhadoresAtivos ? true : null,
                trabalhadoresPcd: incluiTrabalhadoresPCD ? true : null,
                desconsiderarAnotacoesJudiciais: desconsiderarAnotacoesJudiciais ? true : null,
                cpfTrabalhador: isNullOrEmpty(cpfTrabalhador) ? null : cpfTrabalhador.replace(/[^a-zA-Z0-9]/g, ''),
                categorias: isNullOrEmpty(categorias) ? null : String(categorias.reduce((concatCat, cat) => {
                    return isNullOrEmpty(concatCat) ? cat : concatCat + ';' + cat;
                }, '')),
                cbo: isNullOrEmpty(cbo) ? null : String(cbo.reduce((concatCat, cat) => {
                    return isNullOrEmpty(concatCat) ? cat : concatCat + ';' + cat;
                }, '')),
                tipoEstabelecimento: isNullOrEmpty(tipoEstabelecimento) ? null : Number(tipoEstabelecimento),
                estabelecimentos: isNullOrEmpty(estabelecimentos) ? null : estabelecimentos,
                admissaoInicio: isNullOrEmpty(periodoAdmissaoInicio) ? null : periodoAdmissaoInicio,
                admissaoFim: isNullOrEmpty(periodoAdmissaoFim) ? null : periodoAdmissaoFim,
                desligamentoInicio: isNullOrEmpty(periodoDesligamentoInicio) ? null : periodoDesligamentoInicio,
                desligamentoFim: isNullOrEmpty(periodoDesligamentoFim) ? null : periodoDesligamentoFim,
            })
        }
        salvarNovaSolicitacaoRelatorio(relatorio, relatoriosSolicitados, setRelatoriosSolicitados, dispatch, post, navigate);
    }

    useEffect(() => {
        if (opcoesCBO.length == 1) { //significa que não foi carregado
            getConstantes(setOpcoesTipoRelatorio, setDescricaoSituacao, setOpcoesTipoEstabelecimento, setOpcoesCBO, setOpcoesCategorias, dispatch);
        }
    }, []);

    return (
        <Fragment>
            <TituloPagina sx={{ color: '#5E7D61' }}>
                Relatórios Gerenciais - Nova Solicitação
            </TituloPagina>

            <TituloSecao>
                Parâmetros do Relatório
            </TituloSecao>
            <Filtros />
            <ContainerBotaoDireita>
                <ContainerLateral>
                    <Button
                        aria-label={'cancelar solicitação de relatório'}
                        variant="contained"
                        onClick={() => navigate('/gerenciamento')}
                        color="secondary"
                        size="medium">
                        Cancelar
                    </Button>
                    <Button
                        aria-label={'enviar solicitação de relatório'}
                        variant="contained"
                        onClick={handleSolicitarRelatorio}
                        color="primary"
                        size="medium">
                        Solicitar relatório
                    </Button>
                </ContainerLateral>
            </ContainerBotaoDireita>
        </Fragment>
    )
}



export default RelatoriosGerenciaisRegistro;